// removed by extract-text-webpack-plugin
module.exports = {"transitionDurationMs":"1000","wrapper":"_366tGHh","container":"_3PytKwX","show":"_1fuIZin","content":"_1wuV2zN","close":"_16Yw48I","greeting":"_2wGzpIi","cta":"DDNlINf","error":"MvORN1Q"};


//////////////////
// WEBPACK FOOTER
// ./template/components/GDPR/Banner/Banner.css
// module id = ./template/components/GDPR/Banner/Banner.css
// module chunks = client.sitechrome